
import _WsTooltip from './WsTooltip.vue.es.js'
import {app} from '../../core/main.es.js'
import {generateProxy} from '../../proxy.es.js'
import {uikitRenderer} from '../../core/HyperApp.es.js'
const WsTooltip = generateProxy(app, 'ws-tooltip', _WsTooltip, uikitRenderer);
export default WsTooltip;
    